import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getters, actions } from "../model";
import Loading from "ui-kit/Loading";
import Layout from "./Layout";
import EditTypeModal from "./EditTypeModal";

const decorate = connect(
  state => ({
    loading: getters.loading(state)
  }),
  {
    init: actions.init
  }
);

const View = ({
  sessionId,
  viaPortal,
  accentColor,
  init,
  loading,
  hasSubsessions = false,
  isSubsession = false
}) => {
  useEffect(() => {
    init({ sessionId, viaPortal, accentColor });
  }, []);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Layout
          hasSubsessions={hasSubsessions}
          isSubsession={isSubsession}
          viaPortal={viaPortal}
        />
      )}
      <EditTypeModal />
    </>
  );
};

export default decorate(View);
